import { dispatch, select } from '@pressreader/appstore';

import { templatesMerged } from './store/actions';
import { selectTemplates } from './store/selectors';
import { getAllTemplates } from './services';
import { ILegacyTemplate } from './types';

let loadAllPromise: Promise<void> | null = null;

export async function loadAllTemplates(): Promise<void> {
    if (loadAllPromise) return loadAllPromise;

    const existing = select(selectTemplates);
    if (Object.keys(existing).length > 0) return;

    loadAllPromise = getAllTemplates()
        .then(raw => {
            const templates: Record<string, ILegacyTemplate> = {};
            for (const name in raw) {
                if (name && raw[name]) {
                    templates[name] = { name, fnBody: raw[name] };
                }
            }
            if (Object.keys(templates).length > 0) {
                dispatch(templatesMerged(templates));
            }
        })
        .catch(() => {
            loadAllPromise = null;
        });

    return loadAllPromise;
}

export async function loadTemplate(name: string): Promise<ILegacyTemplate | null> {
    const existing = select(selectTemplates);
    if (existing[name]) return existing[name];

    await loadAllTemplates();

    const templates = select(selectTemplates);
    return templates[name] || null;
}
